import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { initialDriverForm } from '../../Data/Constants'
import { addVehicle } from '../../firebase-services/db-services'
import { getVehiclesFetch } from '../../Redux/slices/vehicleState'
import handleChange from '../../Utils/HandleChange'
import { FormInput, FormRow } from '../Controls/Input'
import {  toast } from 'react-toastify';

export default function AddVehicle() {
  const dispatch = useDispatch()
    const [form, setForm] = useState(initialDriverForm)
    const changeHandler = handleChange(form, setForm)
    const submitHandler = (e) => {
        e.preventDefault()
        addVehicle(form).then(res=>{
            dispatch(getVehiclesFetch())
            toast.success("Vehicle Added Successfully")
            //ScrollToTargetAdjusted('transactionTable')
          }).catch(e=>{
            toast.error("Failed to add New Vehicle")
            console.log(e)
          })
        
    }
  return (
    <div id='addVehicleForm' className="bg-gray-100 p-8 rounded-md mx-auto my-36 w-full max-w-7xl">
    <form className='w-full'>
      <h1 className='text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-7'>Add New Vehicle</h1>
      <FormRow mx={3}>
        <FormInput name='name' type="text" label='Vehicle Name' onChange={changeHandler} placeholder={"Vehicle Name"} />
        <FormInput name='vehicle_num' type='text' label='Vehicle No.' placeholder='CG-10-J2486' onChange={changeHandler} />
      </FormRow>
      <FormRow mx={3}>
        <FormInput name='trolly_num' label='Trolly No.' onChange={changeHandler} placeholder="CG-10-M2499" />
      </FormRow>

      <div className='flex flex-row gap-4 mx-4'>
        <button
          className="hover:bg-[#4f48ee] rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
          onClick={submitHandler}
        >
          Submit
        </button>
        <input type="reset"
          className="hover:bg-gray-600 cursor-pointer rounded-md bg-gray-500 py-3 px-8 text-center text-base font-semibold text-white outline-none"
        />
      </div>
    </form>
  </div>
  )
}
